export default [
    {
        value: 0,
        label: '00'
    },
    {
        value: 30,
        label: '30'
    },
];
